import { reactive, computed, onMounted, watch } from '@vue/composition-api'
import * as apiGuide from '@/api/guide'
import * as _ from 'lodash'

export const GuideDetail = (props, context) => {
  const store = context.root.$store
  const { guide } = store.state

  const state = reactive({
    loading: true,
    visibleMenu: false,
    visibleWindowDetail: false,
    numberCarouselVisible: 0, // 表示されているカルーセルの番号
    numberCarouselLength: 1, // カルセールの総数 - 1
    isFocusInput: false
  })

  const action = {
    getDetail: _.throttle(() => {
      state.loading = true
      apiGuide
        .detail({
          id: store.getters['guide/currentId']
        })
        .then(res => {
          const { data } = res
          if (data.status === 0) {
            store.dispatch('guide/setDetail', data)
            store.dispatch('common/addTitle', data.title)
          }
        })
        .finally(() => {
          state.loading = false
        })
    }, 100)
  }

  const sleep = msec => new Promise(resolve => setTimeout(resolve, msec))

  const getTopPageId = async () => {
    let id = store.getters['guide/topPageId']
    if (!id) {
      await sleep(100)
      id = getTopPageId()
    }

    return id
  }

  watch(() => props.guideId, (now, old) => {
    getTopPageId().then(topPageId => {
      const id = now === 'index'
        ? topPageId
        : parseInt(now)

      store.dispatch('guide/setCurrentId', id)
      store.dispatch('guide/currentOpen', id)
      action.getDetail()
    })
  })


  /**
   * SP用テーブル
   */


  return {
    state,
    guide
  }
}
